import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { selectSite } from 'services/site/selectors'
import { selectIsMobile } from 'services/viewport/selectors'
import * as actions from 'services/landing/actions'
import OwnEveryMile from './own-every-mile'
import Syncs from './syncs'
import Features from './features'
import Challenges from './challenges'
import FindYourPath from './find-your-path'
import styles from './_landing.css'

const mapStateToProps = (state) => ({
  site: selectSite(state),
  isMobile: selectIsMobile(state),
})

const mapDispatchToActions = {
  signUp: actions.signUp,
  logIn: actions.logIn,
}

function Landing (props) {
  const { site, signUp, logIn, isMobile } = props
  const { slug } = site
  const showSyncs = slug !== 'ride'

  return (
    <div className={styles.page}>
      <OwnEveryMile site={site} signUp={signUp} logIn={logIn} />
      { showSyncs ? <Syncs /> : null }
      <div className={styles.topoWrapper}>
        <Features site={site} />
        <FindYourPath />
        <Challenges isMobile={isMobile} />
      </div>
    </div>
  )
}

Landing.propTypes = {
  site: PropTypes.object,
  isMobile: PropTypes.bool,
  logIn: PropTypes.func,
  signUp: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(Landing)
